<template>
  <div :class="['px-4 py-2 rounded-lg text-sm flex items-center', colorClass]">
    <component :is="icon" class="size-6 mr-3" />

    <span>
      <slot />
    </span>
  </div>
</template>

<script setup>
import { ExclamationCircleIcon } from "@heroicons/vue/24/outline";

const props = defineProps({
  variant: {
    required: true,
    type: String,
  },

  icon: {
    required: false,
    type: [Function, Object],
    default: () => ExclamationCircleIcon,
  },
});

const colorClass = computed(() => {
  switch (props.variant) {
    case "info":
      return "bg-sky-100 text-sky-600";
    case "yellow":
      return "bg-yellow-100 text-yellow-700";
    case "danger":
      return "bg-orange-100 text-orange-700";
  }
});
</script>
